export default __webpack_public_path__ + "static/media/05-problem-statement.f93bf319.svg";